<template>
  <v-row v-if="product" class="mb-5 mb-sm-7 product-detail">
    <v-col cols="12" sm="6" class="py-0 py-sm-3">
      <v-card flat v-if="selectedImage">
        <!-- <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-img
              class="vendorIcon"
              v-bind="attrs"
              v-on="on"
              v-if="product.vendor.url"
              :src="product.vendor.url"
              height="auto"
              max-width="64"
              contain
              :alt="product.vendor.name"
            />
          </template>
          <span>{{ product.vendor.name }}</span>
        </v-tooltip> -->
        <ProductImages
          :images="product.media"
          :name="product.name"
          :key="product.productId"
        />
      </v-card>
    </v-col>

    <v-col
      cols="12"
      sm="6"
      class="py-0 py-sm-3 default--text gift-expanded-container"
      style="position:relative"
      :class="{ 'text-center': $vuetify.breakpoint.xs }"
    >
      <div class="text-h4 font-weight-bold text-uppercase mb-1">
        {{ product.name }} {{ product.description }}
      </div>
      <div>
        <div class="text-body-1 mb-1">
          {{ product.shortDescr }}
        </div>
        <span
          class="text-caption font-weight-bold"
          v-if="
            product.productInfos.TIPOLOGIA == 'Pezzo' &&
              product.productInfos.PACKAGE_DESCR
          "
        >
          {{ product.productInfos.PACKAGE_DESCR }}
        </span>
      </div>
      <v-row
        no-gutters
        class="mb-4 mb-sm-0 mb-md-3 mt-3"
        justify="center"
        justify-sm="start"
      >
        <ProductClass
          :pClass="pClass"
          :width="27"
          :height="27"
          v-for="pClass in productClasses"
          :key="pClass.productClassId"
        />
      </v-row>

      <div class="promo-wrapper">
        <ProductClass
          :pClass="pClass"
          v-for="pClass in promoProductClasses"
          :key="pClass.productClassid"
        />
        <ProductPromo
          :warehousePromo="product.warehousePromo"
          v-if="product.warehousePromo"
        />

        <ProductGiftCertificate
          v-for="userGiftCertificate in product.userGiftCertificates"
          :key="userGiftCertificate.giftCertificate.giftCertificateId"
          :giftCertificate="userGiftCertificate.giftCertificate"
          @add="giftAdded"
        />
        <!-- <ProductAcqLimit :product="product" class="mr-1" /> -->
      </div>
      <span
        v-if="product.warehousePromo && product.warehousePromo.view.bubble"
        class="promo-badge"
        v-html="product.warehousePromo.view.bubble"
      >
      </span>
      <div
        class="option-wrapper mt-3"
        v-for="selectOption in selectOptionsArray"
        :key="selectOption.name"
        @click.stop.prevent
        @mousedown.stop
      >
        <v-select
          outlined
          dense
          v-model="selectedOptions[selectOption.parameterName]"
          :items="selectOption.options"
          :label="selectOption.name"
          item-text="key"
          item-value="value"
          @change="optionChanged"
        />
      </div>
      <div
        v-if="product.priceDisplay && product.available > 0"
        class="d-flex align-center justify-space-between mb-3 flex-column flex-sm-row"
        :style="{ 'min-height': product.warehousePromo ? '70px' : '' }"
      >
        <ProductPrice :product="product"></ProductPrice>

        <ProductQty
          :selectedOptions="selectedOptions"
          :product="product"
          :item="item"
          :full="true"
        />
      </div>
      <div
        v-else
        class="actions justify-center text-center text-caption error--text font-weight-bold"
      >
        {{ $t("product.notAvailable") }}
      </div>
      <v-divider></v-divider>

      <div class="d-flex flex-column">
        <div class="d-flex align-center" @click="addToFavorites">
          <v-btn icon large>
            <v-icon v-if="highlight" color="primary">$heartfull</v-icon>
            <v-icon v-else>$heart</v-icon>
          </v-btn>

          <span class="text-body-2 add-to-list-text">{{
            $t("product.addToList")
          }}</span>
        </div>
        <div
          class="text-left"
          v-html="$t('productDescription.ingredientsAdditionalInfo')"
        ></div>
      </div>
    </v-col>
  </v-row>
</template>
<style lang="scss">
.product-detail {
  .price {
    margin-bottom: 5px;
  }
  .actions {
    min-height: 58px;
  }
  .promo-wrapper {
    //position: initial;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: row;
    overflow-x: hidden;
    .promo-box,
    .certificate-box {
      margin-right: 2px;
      max-width: 900px;
    }
  }
  .vendorIcon {
    position: absolute;
    right: 6px;
    top: -18px;
    z-index: 6;
  }

  .qty-wrap {
    @media #{map-get($display-breakpoints, 'xs-only')} {
      margin-top: 15px;
    }
  }
  .promo-wrapper {
    max-height: 73px;
    @media #{map-get($display-breakpoints, 'xs-only')} {
      height: auto;
    }
  }
  ::v-deep .old-price {
    font-size: 14px !important;
  }
  ::v-deep .cur-price {
    font-size: 36px;
  }
  ::v-deep .price-um {
    font-size: 12px !important;
    margin-top: 5px !important;
  }
  .add-to-list-text.text-body-2 {
    font-size: 16px !important;
  }
}
</style>
<script>
import ProductPrice from "@/components/product/ProductPrice.vue";
import ProductPromo from "@/components/product/ProductPromo.vue";
import ProductGiftCertificate from "@/components/gift/ProductGiftCertificate.vue";
import ProductClass from "@/components/product/ProductClass.vue";
import ProductImages from "@/components/product/ProductImages.vue";
import ProductQty from "./ProductQty.vue";

import productMixin from "~/mixins/product";
import { mapState, mapGetters } from "vuex";

import cloneDeep from "lodash/cloneDeep";
import forEach from "lodash/forEach";

export default {
  name: "ProductDetail",
  props: ["selectedImage", "product"],
  components: {
    ProductPrice,
    ProductPromo,
    ProductClass,
    ProductImages,
    ProductGiftCertificate,
    ProductQty
  },
  mixins: [productMixin],
  data() {
    return {
      imageDetailDialog: false,
      selectedOptions: {},
      selectOptionsArray: []
    };
  },
  computed: {
    ...mapGetters({
      getItem: "cart/getItem"
    }),
    ...mapState({
      cart: ({ cart }) => cart.cart
    }),
    item() {
      let item = this.getItem({
        product: this.product,
        ...this.selectedOptions
      });
      return item;
    },
    promoProductClasses() {
      return this.product.productClasses.filter(
        pClass => pClass.productClassGroupId === 6
      );
    }
  },
  methods: {
    selectImage(media) {
      this.$emit("selectImage", media);
    },
    openImageDialog() {
      this.imageDetailDialog = true;
    },
    setOptionsArray() {
      if (this.product.selectOptions && this.product.selectOptions.length) {
        this.selectOptionsArray = cloneDeep(this.product.selectOptions);
        forEach(this.selectOptionsArray, a => {
          a.options.unshift({ key: "-", value: "-" });
        });
      } else {
        this.selectOptionsArray = [];
      }
    },
    giftAdded() {
      this.plus();
    }
  },
  created() {
    this.setOptionsArray();
  },
  watch: {
    product(val, oldVal) {
      if (val.productId !== oldVal.productId) {
        this.setOptionsArray();
      }
    }
  }
};
</script>
